import { Flex, Button, Box } from '@chakra-ui/react';
import { decode } from 'js-base64';
import { useMemo, useCallback } from 'react';
import { NotificationCard } from '../../components/Card';
import { NotificationTime } from '../../components/Time';
import { KText } from '@/ui-library/components';
import { MicrosoftLogo } from '@/assets/icons/microsoft';

const ReconnectMicrosoftMeetingRoomsContent = ({
  notification = {},
  onClose = () => {},
}) => {
  const { custom_attributes } = notification;

  // BE (core#5284) sets `custom_attributes.url` to the account's
  // Settings → Meeting Rooms deep-link, delivered base64-encoded like the
  // other reconnect notifications.
  const { url } = useMemo(() => {
    try {
      if (!custom_attributes) return {};
      return JSON.parse(decode(custom_attributes));
    } catch (err) {
      console.error(
        'Error decoding reconnect microsoft meeting rooms notification',
        err
      );
      return {};
    }
  }, [custom_attributes]);

  const handleReauthenticate = useCallback(() => {
    if (url) {
      window.open(url, '_self');
      onClose();
    }
  }, [url, onClose]);

  return (
    <Flex alignItems="start" gap="14px">
      <Box
        px="12px"
        pt="8px"
        pb="10px"
        borderRadius="8px"
        bg="pastel-1-light"
        flexShrink={0}
      >
        <MicrosoftLogo width="16" height="16" />
      </Box>
      <Flex flexDir="column" gap="8px" alignSelf="start" flex="1">
        <KText>
          Your Microsoft meeting rooms integration has expired. Reauthenticate
          to continue booking meeting rooms for interviews.
        </KText>
        <NotificationTime notification={notification} />
        <Button
          variant="primary"
          size="sm"
          w="fit-content"
          onClick={handleReauthenticate}
          data-test-id="reauthenticate-microsoft-meeting-rooms-button"
        >
          Reauthenticate
        </Button>
      </Flex>
    </Flex>
  );
};

export const ReconnectMicrosoftMeetingRoomsNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <ReconnectMicrosoftMeetingRoomsContent
        notification={notification}
        onClose={onClose}
      />
    </NotificationCard>
  );
};
